import moment from 'moment';

import callApi from '../../util/apiCaller';
import { getPriceFromCent, getPriceCent } from '../../util/price';


import { getCartItemsTotals, getCartSubscription } from '../Cart/CartActions';
import { getOrdersByUser } from '../Order/OrderActions';
import { getLoggedUser } from '../User/UserActions';
import { addError } from '../Error/ErrorActions';

// Export Constants
export const SET_VOUCHERS = 'SET_VOUCHERS';
export const APPLY_VOUCHER = 'APPLY_VOUCHER';

// Export Actions

export function getVouchersRequest() {
    return dispatch => {
        return callApi('vouchers').then(res => {
            if(res.vouchers) {
                dispatch(setVouchers(res.vouchers));
            }
            return res.vouchers;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function getPublicVouchersRequest(refreshCache = false) {
    return dispatch => {
        return callApi(`vouchers/public${refreshCache ? '?refreshCache=1' : ''}`).then(res => {
            if(res.vouchers) {
                dispatch(setVouchers(res.vouchers));
            }
            return res.vouchers;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function editVoucherRequest(voucher) {
    return dispatch => {
        return callApi('voucher/edit', 'post', { voucher }).then(res => {
            if(res.voucher) {
                dispatch(setVouchers([res.voucher]));
            }
            return res.voucher;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function applyVoucherRequest(code) {
    return dispatch => {
        return callApi('voucher/apply', 'post', { voucher: { code: `${code}`.toUpperCase() } }).then(res => {
            if(res.voucher) {
                dispatch(applyVoucher(res.voucher));
            }
            return res.voucher;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}


export function getVoucher(store, voucherId) {
    return store.vouchers.data.find(voucher => voucher._id === voucherId);
}

export function getVoucherByCode(store, voucherCode) {
    return store.vouchers.data.find(voucher => {
        return voucher.code === (voucherCode && voucherCode.toUpperCase());
    });
}

export function getVouchers(store, isActive = null) {
    let vouchers = store.vouchers.data;
    if(isActive !== null) {
        vouchers = vouchers.filter(voucher => voucher.isActive === isActive);
    }
    return vouchers;
}

export function checkVoucherConditionsFromStore(store, voucher, user = null) {
    const subtotal = getCartItemsTotals(store);
    user = user || getLoggedUser(store);
    const orders = user ? getOrdersByUser(store, user._id, ['onpreparation', 'shipped', 'complete', 'archived']) : [];
    return checkVoucherConditions(voucher, user, orders, subtotal, !!getCartSubscription(store));
}

export function checkVoucherConditions(voucher, user, orders, subtotal, isSubscription = false) {
    return voucher && (voucher.conditions || []).every(condition => {
        let value = '';
        let conditionValue = condition.value;
        // console.log(condition);

        switch(condition.key) {
            case 'use':
                value = voucher.useCount;
                break;

            case 'usePerUser':
                value = orders ? orders.filter(order => order.vouchers && order.vouchers.find(voucherUsed => voucherUsed && voucherUsed._id === voucher._id)).length : 0;
                break;

            case 'user':
                value = user && user._id;
                break;

            case 'subtotal':
                value = subtotal;
                break;

            case 'subscription':
                value = isSubscription ? '1' : '0';
                break;

            case 'date':
                value = moment.utc().toDate();
                conditionValue = moment(condition.value).toDate();
                break;

            default:
                break;
        }

        let result = false;
        switch(condition.operator) {
            case '==':
                result = value === conditionValue;
                break;

            case '!=':
                result = value !== conditionValue;
                break;

            case '<=':
                result = value <= conditionValue;
                break;

            case '<':
                result = value < conditionValue;
                break;

            case '>=':
                result = value >= conditionValue;
                break;

            case '>':
                result = value > conditionValue;
                break;

            default:
                break;
        }
        // !result && console.log(condition.key, `${value} ${condition.operator} ${conditionValue}`, result);
        return result;
    });
}

export function getVoucherDiscountValue(voucher, subtotal, shippingFee) {
    return getPriceFromCent((voucher ? (voucher.actions || []) : []).reduce((discount, action) => {
        if(action.type === 'fixed') {
            return discount + getPriceCent(action.value);
        } if(action.type === 'percentage') {
            let reference = 0;
            switch(action.key) {
                case 'subtotal':
                    reference = subtotal;
                    break;

                case 'shipping':
                    reference = shippingFee;
                    break;

                default:
                    break;
            }

            return discount + getPriceCent((action.value * reference) / 100);
        }
        return discount;
    }, 0));
}

export function getAvailableConditionKeys() {
    return ['use', 'usePerUser', 'user', 'subtotal', 'date', 'subscription'];
}

export function getAvailableConditionOperators() {
    return ['<', '<=', '==', '>=', '>', '!='];
}

export function getAvailableActionKeys() {
    return ['subtotal', 'shipping'];
}

export function getAvailableActionTypes() {
    return ['fixed', 'percentage'];
}

export function setVouchers(vouchers) {
    return {
        type: SET_VOUCHERS,
        vouchers,
    };
}

export function applyVoucher(voucher = {}) {
    return {
        type: APPLY_VOUCHER,
        voucher,
    };
}
